import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';
import type { IsomorphicEnvironment } from '#/contexts/UserEnvironmentContext';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { UserDashboardApiApplicantProfile } from '#/modules/userDashboard/api/applicantProfile/types/UserDashboardApiApplicantProfile';
import type { UserDashboardApiEmptyApplicantProfile } from '#/modules/userDashboard/api/applicantProfile/types/UserDashboardApiEmptyApplicantProfile';

import { isNonAdmin } from './userEnvironment';

export function hasResumeDb(
  user: ApiUser | null,
  isomorphicEnvironment: IsomorphicEnvironment,
  locale: I18nLocale,
): boolean {
  if (!user) return false;
  if (locale !== I18nLocale.EN) return false;

  return isomorphicEnvironment.isUS || Boolean(user.isRecruitable);
}

export function hasWorkHistoryJobs(
  profile:
    | UserDashboardApiApplicantProfile
    | UserDashboardApiEmptyApplicantProfile,
): boolean {
  if (!profile) return false;

  return profile.workHistoryJobs.length > 0;
}

export function promoteResumeDatabase(
  user: ApiUser | null,
  isomorphicEnvironment: IsomorphicEnvironment,
  locale: I18nLocale,
) {
  if (!hasResumeDb(user, isomorphicEnvironment, locale)) return false;

  if (user) {
    if (!isNonAdmin(user)) return false;

    if (user.isRecruitable === false) return false;
    if (user.isRecruitable && user.resumeId) return false;
  }

  return true;
}
